import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { Subscribe, SubscriberList, Unsubscribe, AdminLogin, AdminPanel, AdminEmails, AdminEmailEditor, AdminTracking } from './pages';
import { AuthProvider } from './providers/authProvider';
import { Portfolio } from 'src/pages/Portfolio';

const router = createBrowserRouter([
  {
    path: '/',
    element: <Subscribe />,
  },
  {
    path: '/portfolio',
    element: <Portfolio />,
  },
  {
    path: '/admin/login',
    element: <AdminLogin />,
  },
  {
    path: '/admin/subscribers',
    element: <SubscriberList />,
  },
  {
    path: '/admin/emails',
    element: <AdminEmails />,
  },
  {
    path: '/admin/tracking',
    element: <AdminTracking />,
  },
  {
    path: '/admin/emails/:id',
    element: <AdminEmailEditor />,
  },
  {
    path: '/admin',
    element: <AdminPanel />,
  },
  {
    path: "/unsubscribe",
    element: <Unsubscribe/>,
  },
]);

const container = document.getElementById('app');
const root = ReactDOM.createRoot(container);
root.render(
  <React.StrictMode>
    <AuthProvider>
      <RouterProvider router={router} />
    </AuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
